import React from "react";

type LogoLoaderProps = {
  caption?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeClassMap: Record<NonNullable<LogoLoaderProps["size"]>, string> = {
  sm: "logo-loader-image-sm",
  md: "logo-loader-image-md",
  lg: "logo-loader-image-lg",
};

const LOGO_URL =
  "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev/images/home/logo.png";

const sparkleAngles = [0, 60, 120, 180, 240, 300];

const orbitRadiusPx: Record<NonNullable<LogoLoaderProps["size"]>, number> = {
  sm: 88,
  md: 126,
  lg: 152,
};

const LogoLoader: React.FC<LogoLoaderProps> = ({
  caption,
  size = "md",
  className = "",
}) => {
  const sizeClass = sizeClassMap[size];
  const orbitR = orbitRadiusPx[size];

  return (
    <div className={`logo-loader ${className}`.trim()} role="status" aria-live="polite">
      <div className={`logo-loader-shell logo-loader-shell-${size}`.trim()}>
        <div className="logo-loader-orbit" aria-hidden="true">
          {sparkleAngles.map((angle) => (
            <span
              key={angle}
              className="logo-loader-sparkle-orbit-item"
              style={{ transform: `rotate(${angle}deg) translateX(${orbitR}px)` }}
            >
              <span className="logo-loader-sparkle-wrap">
                <span className="logo-loader-sparkle-shape" />
              </span>
            </span>
          ))}
        </div>
        <div className="logo-loader-brand">
          <img src={LOGO_URL} alt="" aria-hidden="true" className={`logo-loader-image logo-loader-image-gray ${sizeClass}`} />
          <div className="logo-loader-fill-mask" aria-hidden="true">
            <img src={LOGO_URL} alt="" aria-hidden="true" className={`logo-loader-image logo-loader-image-color ${sizeClass}`} />
          </div>
          <span className="sr-only">MySipur</span>
        </div>
      </div>
      {caption ? <p className="logo-loader-caption">{caption}</p> : null}
    </div>
  );
};

export default LogoLoader;
